import { Content } from "containers/RightPanel/RightPanel.styles";
import { fadeIn } from "react-animations";
import { Col, Container, Row } from "react-grid-system";
import styled, { keyframes } from "styled-components";
import { Currency } from "../../../styles/parcelsStyles";

interface AddFundsBlockProps {
  $isPanelOpened: boolean;
  $isBlockPanel?: boolean;
}

export const AddFundsBlock = styled.div<AddFundsBlockProps>`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  button {
    text-wrap: nowrap;
  }

  img {
    width: 60px;
    height: 40px;
  }

  ${({ $isBlockPanel }) =>
    $isBlockPanel &&
    `
    flex-wrap: nowrap;

    input {
      max-width: 170px;
    }`}

  ${({ theme, $isPanelOpened }) =>
    $isPanelOpened &&
    theme.range(
      "padding-right",
      "370px",
      "410px",
      `${theme.breakpoints.lg}px`,
      `${theme.breakpoints.xl}px`,
    )}
`;

export const ContentContainer = styled(Content)`
  & > div:first-child {
    display: flex;
    flex-direction: column;
  }
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding-top: 15px;

  @media (max-width: ${({ theme }) => theme.breakpoints.xs}px) {
    padding-top: 5px;
  }
`;

export const AddFundsFormRow = styled(Row)`
  margin-bottom: 15px;

  ${({ theme }) => theme.xs`
    margin-left: 0;
    margin-right: 0;
  `}
`;

export const AddFundsFormCol = styled(Col)`
  ${({ theme }) => theme.xs`
    padding-left: 0;
    padding-right: 0;
  `}
`;

export const AddFundsAmountRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  ${({ theme }) => theme.xs`
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  `}
`;

export const AddFundsAmountValue = styled.div`
  width: 100%;
  max-width: 130px;

  ${({ theme }) => theme.xs`
    max-width: 100%;
  `}
`;

export const BooksAddFundsFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const BooksVoucherCreateFormWrapper = styled(BooksAddFundsFormWrapper)`
  height: 100%;
`;

interface ParcelRowProps {
  checked?: boolean;
  selected?: boolean;
}

export const PaymentFundsRow = styled(Row)<ParcelRowProps>`
  cursor: pointer;
  ${({ theme }) => theme.range("padding", "10px", "16px")};
  white-space: nowrap;
  animation: 0.3s ${keyframes`${fadeIn}`};
  &.row {
    margin: 0;
  }

  min-height: 68px;

  &:not(:first-child) {
    border-top: none;
  }

  ${({ theme, checked, selected }) => `
    border-top: 1px solid ${theme.lightgrey};
    border-bottom: 1px solid ${theme.lightgrey};
    background-color: ${
      (checked && theme.checkedRowBg) || (selected && theme.selectedRowBg)
    };

    &:hover {
      background-color: ${checked || theme.selectedRowBg};
    }
  `};

  ${(props) => props.theme.sm`
    padding: 15px 0 15px 0px;
    font-size: 13px;
  `}

  ${(props) => props.theme.xs`
    font-size: 12px;
    padding: 15px 0 5px 0;
  `};
`;

export const PaymentFundsCol = styled(Col)`
  display: flex;
  gap: 20px;
  align-items: center;
`;

export const PaymentImgIcon = styled.div`
  width: 60px;
  min-width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    max-width: 60px;
    object-fit: contain;
  }
`;

export const StripeWordmark = styled.strong`
  color: #635bff;
  font-size: 20px;
  letter-spacing: -1px;
`;

export const AddFundsContainer = styled(Container)`
  width: 100%;

  ${({ theme }) => theme.xs`
    padding-left: 0;
    padding-right: 0;
  `}
`;

export const HistoryItemRow = styled(Row)`
  animation: 0.3s ${keyframes`${fadeIn}`};
  padding: 10px 0;

  ${({ theme }) => `
    border-bottom: 1px solid ${theme.lightgrey};
  };
  `};
`;

export const HistoryItemFirstCol = styled(Col)`
  flex: 2 !important;
`;

export const VoucherResponseCodeWrapper = styled.div`
  padding: 30px 0;
  margin: 0 15px;
  background: ${({ theme }) => theme.checkedRowBg};
  text-align: center;
  width: 100%;
`;

export const VoucherResponseCodeText = styled.div`
  font-weight: bold;
  font-size: 18px;
`;

export const BooksBalancePanelSection = styled.div`
  width: 100%;
  padding: 0 15px;

  ${({ theme }) => theme.xs`
    padding: 0;
  `}
`;

export const BooksBalanceLayout = styled.div`
  width: 100%;
  max-width: 350px;
  margin: 0 auto;

  ${({ theme }) => theme.md`
    max-width: 100%;
  `}
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-right: 4px;
  }

  i {
    margin-left: 4px;
  }
`;

export const PriceItem = styled.li`
  display: flex;
  justify-content: space-between;
  list-style: none;
  white-space: nowrap;
  margin-bottom: 10px;

  &:last-child {
    font-size: 16px;
    margin-top: 10px;

    div {
      font-weight: 700;
    }
  }
`;

export const SummaryPriceItem = styled(PriceItem)`
  justify-content: flex-end;
`;

export const SummaryPriceWrapper = styled(PriceWrapper)`
  min-width: 50px;
  margin-left: 8px;
  justify-content: flex-end;
`;

export const SummaryCurrency = styled(Currency)`
  margin-right: 0 !important;
`;
